<template>
  <div class="no-content-box" :class="{ 'gray-no-content-box': type == 4 }">
    <img
      class="no-content"
      src="@/assets/images/tip/no-content.png"
      v-if="type == 1"
      alt=""
    />
    <img
      class="no-search-content"
      src="@/assets/images/tip/no-search-content.png"
      v-else-if="type == 2"
      alt=""
    />
    <img
      class="no-message-content"
      src="@/assets/images/tip/no-message-content.png"
      v-else-if="type == 3"
      alt=""
    />
    <img
      class="gray-no-content"
      src="@/assets/images/tip/gray-no-content.png"
      v-else-if="type == 4"
      alt=""
    />
    <img
      src="@/assets/images/tip/no-search.png"
      class="no-search"
      alt=""
      v-else-if="type == 5"
    />
    <div class="content-info">
      <div class="tip-title" v-html="message"></div>
      <a v-if="paramsUrl" class="jump-url" :href="paramsUrl.url">
        {{ paramsUrl.text }}
        <i class="iconfont icon-down-arrow"></i>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 1没有内容2没有搜索结果3没有消息
    type: {
      type: [Number, String],
      default: 1,
    },
    message: {
      type: String,
      default: "无法预览",
    },
    // 需要跳转的地址
    paramsUrl: {
      type: Object,
      default: null,
    },
  },
};
</script>
<style lang="scss" scoped>
.no-content-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;
  .no-content {
    width: 264px;
    height: 180px;
  }
  .no-search-content {
    width: 240px;
    height: 196px;
  }
  .no-message-content {
    width: 266.4px;
    height: 227px;
  }
  .gray-no-content {
    width: 155px;
    height: 106px;
  }
  .no-search {
    width: 186px;
    height: 125px;
  }
  .tip-title {
    color: #000;
    font-size: 14px;
    line-height: 22px;
    margin-top: 4px;
  }
  .content-info {
    margin-top: 10px;
    display: flex;
    align-items: center;
    font-size: 13px;
    line-height: 22px;
    .tip-title {
      margin-right: 12px;
      margin-top: 0;
    }
    .jump-url {
      display: flex;
      align-items: center;
      color: #0057ff;
      .icon-down-arrow {
        font-size: 12px;
        transform: scale(0.8) rotate(-90deg);
        margin-left: 4px;
      }
    }
  }
  &.gray-no-content-box {
    margin-top: 54px;
    margin-bottom: 49px;
  }
}
</style>
